/**
  * @class meleSearch
  * @description
  * @deprecated DONT USE ANY MORE, USE MELE-LIST WITH SEARCHBAR INSTEAD
  *
  * # Purpose
  * Implements `<mele-search>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-search></mele-search>';
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-search',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleList from 'meleList'

const PROPERTIES = _.extend({}, {
  tabs: { type: 'stringorarray', description: 'list of tabs (types of items) displayed for filtering' },
  tab: { type: 'string', description: 'current tab; empty shows all items' },
  count: { type: 'integer', description: 'number of items in search' },
}, meleList._properties)

export default class meleSearch extends meleList {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    super.init()
    this.count = 0
    super.searchbarChanged(true) // force show of searchbar
    this._searchicon = this._search_wrapper.appendChildren({
      tag: 'mele-image',
      key: 'searchicon',
      icon: 'u.search',
    })

    this._tabs_wrapper = this._header_wrapper.appendChildren({
      tag: 'mele-header',
      key: 'tabs',
    })
    this._tabs = this._tabs_wrapper.appendChildren({
      tag: 'mele-list',
      direction: 'row',
      design: 'tabs',
      iconleft: '${prefix}${key}',
      tooltip: '${prefix}${key}',
      blank: true,
      selected: [''],
      eventSelected: (el, selected)=>{
        this.tab=selected[0]
        this._search.find('input').focus()
      },
    })

    const orig = this._search.focusedChanged.bind(this._search)
    this._search.focusedChanged = (value)=>{
      this.searchfocused=value
      orig(value)
    }
  } // init

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "searchbar"
  */
  searchbarChanged(value) {
    // do nothing to prevent hiding searchbar
  } // searchbarChanged

  tabsChanged(value) {
    if(Array.isArray(value)) {
      this._tabs.prefix = ''
      this._tabs.auto = false
      this._tabs.items = value
    }else if(typeof (value)==='string') {
      this._tabs.items = []
      this._tabs.prefix = value
      this._tabs.auto = true
    }else{
      this._tabs.items = []
      this._tabs.auto = false
      this._tabs.prefix = ''
    }
  } // tabsChanged

  _filterItems() {
    super._filterItems()
    const tab = this.tab
    if(tab) {
      this._body.forAll('>:not([key=":comber"])', el=>{
        if(el.tab != tab) el.hidden = true
      })
    }
  }

  tabChanged(value) {
    this._tabs.selected = [value]
    this._filterItems()
  } // tabChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "search"
  */
  searchChanged(value) {
    value = _.toString(value)
    this._search.value = value
    this.deleteItems()
    if(typeof this.eventSearch==='function') {
      this.eventSearch(this, value)
    }
  } // searchChanged

  updateSearch(search, items) {
    const current_search = _.toString(this.search)
    if(!Array.isArray(items) || current_search != _.toString(search)) return // search field changed before the response came
    this.updateItems(items)
    this.count = this.getItemElements().length
  }
} // meleSearch

meleSearch._properties = PROPERTIES
meleSearch.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-search', meleSearch)
